/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Weight unit of measure. Supported values are:
 * - kg (kilograms)
 * - lb (pounds)
 *
 */
export var WeightUomEnum;
(function (WeightUomEnum) {
    WeightUomEnum["KG"] = "kg";
    WeightUomEnum["LB"] = "lb";
})(WeightUomEnum || (WeightUomEnum = {}));
